import React from "react";

export const AppConfigContext = React.createContext({});

export function withAppConfig(Component){
    return function ConfigComponent(props){
        return (
            <AppConfigContext.Consumer>
                { appConfig => appConfig ? <Component {...props} configJSON={appConfig} /> :null}
            </AppConfigContext.Consumer>
        )
    }
}